import React from 'react';
import RecommendedProduct from './RecommendedProduct.jsx';
import QuizResultExtra from './QuizResultExtra.jsx';
import Col from 'kepler/lib/components/Col';
import Row from 'kepler/lib/components/Row';
import PropTypes from 'prop-types';
import { get } from 'lodash';
class QuizResults extends React.Component {
  componentDidMount() {
    const { fptiHelper, location } = this.props;
    fptiHelper.fptiImpression({
      page: 'main:businessweb:mep:dashboard:main:quiz:results',
      entry_point: get(location, 'search', '').includes('appcenter=true')
    });
  }
  render() {
    const {
      userProducts,
      developerProducts,
      extras,
      app,
      location,
      fptiHelper
    } = this.props;
    return (
      <Row className="results" style={{ marginTop: '20px' }}>
        <Col className="results-products" sm="70%">
          {/* Need app */}
          <RecommendedProduct
            userProducts={userProducts}
            developerProducts={developerProducts}
            app={app}
            location={location}
            fptiHelper={fptiHelper}
          />
        </Col>
        <Col className="results-extra-products" sm="30%">
          <QuizResultExtra
            extras={extras}
            location={location}
            fptiHelper={fptiHelper}
          />
        </Col>
      </Row>
    );
  }
}
QuizResults.propTypes = {
  userProducts: PropTypes.object,
  developerProducts: PropTypes.object,
  extras: PropTypes.array,
  app: PropTypes.object,
  location: PropTypes.object,
  fptiHelper: PropTypes.object
};
export default QuizResults;
